import XCircled from './XCircled'

export default XCircled
// eslint-disable-next-line import/export
export * from './XCircled'
